module.exports = __webpack_public_path__ + "img/scene2-9.268a9dcd.jpg";